import { render, staticRenderFns } from "./noticeDetail.vue?vue&type=template&id=77600f68&scoped=true"
import script from "./noticeDetail.vue?vue&type=script&lang=js"
export * from "./noticeDetail.vue?vue&type=script&lang=js"
import style0 from "./noticeDetail.vue?vue&type=style&index=0&id=77600f68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77600f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77600f68')) {
      api.createRecord('77600f68', component.options)
    } else {
      api.reload('77600f68', component.options)
    }
    module.hot.accept("./noticeDetail.vue?vue&type=template&id=77600f68&scoped=true", function () {
      api.rerender('77600f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/notice/noticeDetail.vue"
export default component.exports